import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import { ChequeNoteClearingStatusEnum } from 'common/constants/enum';
import { CommonModel } from 'common/repositories/common.model';

export enum ClearingStatusEnum {
  rejected = 'rejected',
  cleared = 'cleared',
}

export class ClearingModel {
  id: string;
  status: ChequeNoteClearingStatusEnum;
  order: number;

  @Expose({ name: 'clearing_at' })
  @Type(() => Date)
  clearingAt: Date;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class BankAccountModel extends CommonModel {
  code: string;
  description: string;
  name: string;

  @Expose({ name: 'account_number' })
  accountNumber: string;

  @Type(() => Number)
  balance: number;
}

export class ChequeGiroModel extends CommonModel {
  name: string;

  @Expose({ name: 'bank_code' })
  bankCode: string;
}

export class ChequeGiroClearingLiteModel extends CommonModel {
  type: string;
  status: string;

  @Expose({ name: 'reference_number' })
  referenceNumber: string;

  @Expose({ name: 'issued_at' })
  @Type(() => Date)
  issuedAt: Date;

  @Expose({ name: 'available_at' })
  @Type(() => Date)
  availableAt: Date;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountModel)
  bankAccount: BankAccountModel;

  @Expose({ name: 'cheque_giro' })
  @Type(() => ChequeGiroModel)
  chequeGiro: ChequeGiroModel;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class ChequeGiroClearingModel {
  id: string;
  type: string;
  status: string;

  @Expose({ name: 'reference_number' })
  referenceNumber: string;

  @Expose({ name: 'cheque_giro' })
  @Type(() => ChequeGiroModel)
  chequeGiro: ChequeGiroModel;

  @Expose({ name: 'issued_at' })
  @Type(() => Date)
  issueAt: Date;

  @Expose({ name: 'available_at' })
  @Type(() => Date)
  availableAt: Date;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountModel)
  bankAccount: BankAccountModel;

  @Expose({ name: 'cheque_note_clearings' })
  @Type(() => ClearingModel)
  chequeNoteClearings: ClearingModel[];
}

export class getChequeGiroClearingsInput {
  params: {
    page: number;
    limit?: number;
    q?: string;
  };
}

export class getChequeGiroClearingInput {
  id: string;
}

export class ClearingMutationInput {
  status: string | null;
  clearingAt: Date | null;
}

export class ChequeGiroClearingCreateInput {
  chequeGiroId: string | undefined;
  body: ClearingMutationInput;
}

export class ChequeGiroClearingUpdateInput {
  chequeGiroClearingId: string;
  body: ClearingMutationInput;
}

export class ChequeGiroClearingDeleteInput {
  chequeGiroClearingId: string | undefined;
}
